import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorHandlerService } from './http-error-handler.service';
import { SuperAdminProxyService } from '../super-admin-proxy.service';

@Injectable()
export class APIInterceptor implements HttpInterceptor {

  constructor(
    private errorHandler: HttpErrorHandlerService,
    private superAdminProxy: SuperAdminProxyService
  ) { }

  /** Super-admin-only routes must not send org proxy header (would turn JWT into type 2). */
  private shouldSkipSuperAdminProxyHeader(url: string): boolean {
    const u = url.toLowerCase();
    return (
      u.includes('/organizations/invite') ||
      u.includes('/organizations/invite-stats') ||
      u.includes('/admin/subscriptions')
    );
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let token: string | null = null;

    // Safely parse the token
    try {
      const user = localStorage.getItem('user');
      if (user) {
        const userParse = JSON.parse(user);
        token = userParse?.token || null;
      }
    } catch (e) {
      console.warn("Invalid user token in localStorage", e);
    }

    // Add headers only if token is available
    if (token) {

      // Skip setting Content-Type if body is FormData (e.g., for file upload)
      const isFormData = request.body instanceof FormData;

      let headers = new HttpHeaders({
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "69420"
      });

      if (!isFormData) {
        headers = headers.set('Content-Type', 'application/json');
      }

      const proxyOrgId = this.superAdminProxy.getProxyOrgId();
      if (proxyOrgId != null && !this.shouldSkipSuperAdminProxyHeader(request.url)) {
        headers = headers.set('X-Proxy-Organization-Id', String(proxyOrgId));
      }

      const authReq = request.clone({ headers });
      return next.handle(authReq).pipe(
        catchError((error: HttpErrorResponse) => {
          this.errorHandler.handleError(error);
          return throwError(() => error);
        })
      );
    }else{
       let headers = new HttpHeaders({
        "ngrok-skip-browser-warning": "69420"
      });
       const authReq = request.clone({ headers });
      return next.handle(authReq).pipe(
        catchError((error: HttpErrorResponse) => {
          this.errorHandler.handleError(error);
          return throwError(() => error);
        })
      );
    }


    // Default pass-through if no token
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        this.errorHandler.handleError(error);
        return throwError(() => error);
      })
    );
  }
}
